import { ICPlatformVersion } from '@retailer-platform/dashboard/access-control'
import { type DomainAccessControlConfig } from '../utils/domain/accessControl'
import { Permission } from './permissions'
import { FeatureToggle } from './featureToggles'

// Gates ordinary IPM navigation and non-review pages. `browse` is intentionally a UI-only
// capability; `view` remains the data/AMS permission and is included so enabling the tool in
// role management grants both permissions needed for a functional browsing experience.
// The minICPlatformVersion ties IPM to the R2026_08 release train: external retailers
// only see it once their site is on r2026_08_0, while the itemPriceManagement feature toggle
// stays as a secondary kill-switch (ANDed with the version). Internal users bypass the version
// check by default and can emulate other versions via Admin Controls.
export const itemPriceManagementBrowseAccessControl = {
  featureToggles: [FeatureToggle.itemPriceManagement],
  permissions: [Permission.ItemPriceManagementBrowse, Permission.ItemPriceManagementView],
  minICPlatformVersion: ICPlatformVersion.r2026_08_0,
} satisfies DomainAccessControlConfig

// The review URL is a sibling of the browse-gated router so Partner Approvers can reach it
// without receiving access to ordinary IPM pages. AMS still makes the per-request action
// decision using the stage-specific approve permission.
export const itemPriceManagementReviewRouteAccessControl = {
  featureToggles: [FeatureToggle.itemPriceManagement],
  permissions: [Permission.ItemPriceManagementView, Permission.ItemPriceManagementReview],
  minICPlatformVersion: ICPlatformVersion.r2026_08_0,
} satisfies DomainAccessControlConfig

export const itemPriceManagementModifyAccessControl: DomainAccessControlConfig = {
  permissions: [Permission.ItemPriceManagementModify],
}

export const itemPriceManagementDeleteChangeRequestAccessControl: DomainAccessControlConfig = {
  permissions: [Permission.ItemPriceManagementDeleteChangeRequest],
}

export const itemPriceManagementReviewAccessControl: DomainAccessControlConfig = {
  permissions: [Permission.ItemPriceManagementReview],
}

export const itemPriceManagementPartnerApproveAccessControl: DomainAccessControlConfig = {
  permissions: [Permission.ItemPriceManagementPartnerApprove],
}

export const itemPriceManagementDebugAccessControl: DomainAccessControlConfig = {
  permissions: [Permission.ItemPriceManagementDebug],
}
